export { default as AdminListListItemBodyMobile } from './AdminListListItemBodyMobile';

export type {
  AdminListListItemBodyMobileProps,
  AdminListListItemBodyMobileComponent,
} from './AdminListListItemBodyMobile.type';
